import { BreadcrumbJsonLd } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { locales } from '@consts/consts';

type IBreadrumbs = {
  product?: string;
  // type: string;
};

export const Breadcrumb: React.FC<IBreadrumbs> = ({ product }) => {
  const router = useRouter();
  const { t, lang } = useTranslation('common');
  const paths = router.asPath.split('/');

  const link = (paths: string[], size: number) => {
    const href = paths
      .slice(0, size + 1)
      .map((item) => `${item}`)
      .join('/');
    return href.toString().replace(/\/$/, '');
  };

  const isProduct = product !== undefined ? 2 : 1;

  const domain = ($lang: string) => {
    switch ($lang) {
      case 'en':
      default:
        return 'https://knswindows.com';
      case 'pl':
        return 'https://knsokna.pl';
      case 'de':
        return 'https://knsfenster.de';
      case 'cs':
        return 'https://kns-okna.eu';
      case 'it':
        return 'https://knsfinestre.it';
      case 'fr':
        return 'https://knsfenetres.fr';
      case 'hu':
        return 'https://knsokna.eu';
    }
  };

  return (
    <nav className="flex my-2" aria-label="Breadcrumb">
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: t('home.title'),
            item: `${domain(lang)}/`,
          },
          paths.length > 1 && {
            position: 2,
            name: t(`${paths[1]}.title`),
            item: `${domain(lang)}/${paths[1]}`,
          },
          paths.length > 2 && {
            position: 3,
            name: isProduct === 2 ? product : t(`${paths[1]}.${paths[2]}`),
            item: `${domain(lang)}/${paths[1]}/${paths[2]}`,
          },
          paths.length > 3 && {
            position: 4,
            name: isProduct === 2 ? product : t(`${paths[3]}`),
            item: `${domain(lang)}/${paths[1]}/${paths[2]}/${paths[3]}`,
          },
          paths.length > 4 && {
            position: 5,
            name: isProduct === 2 ? product : t(`${paths[4]}.title`),
            item: `${domain(lang)}/${paths[1]}/${paths[2]}/${paths[3]}/${
              paths[4]
            }`,
          },
        ].filter(Boolean)}
      />
      <ol className="inline-flex items-center space-x-1">
        <li className="inline-flex items-center">
          <a
            href={lang === 'en' ? '/' : `/${lang}`}
            className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-black"
          >
            <svg
              className="w-4 h-4 "
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
            </svg>
          </a>
        </li>
        {[...Array(paths.length - isProduct)].map((_, i) => (
          <li key={i + 1}>
            <div className="flex items-center">
              <svg
                className="w-6 h-6 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <Link
                href={link(paths, i + 1)}
                className="ml-1 text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2 dark:text-gray-400 dark:hover:text-black"
                prefetch={false}
              >
                {i === 0 && t(`${paths[i + 1]}.title`)}
                {i === 1 && t(`${paths[i]}.${paths[i + 1]}`)}
                {i === 2 && t(`${paths[i + 1]}`)}
                {/* {paths[i + 1]} */}
              </Link>
            </div>
          </li>
        ))}
        {isProduct === 2 && (
          <li key={paths.length}>
            <div className="flex items-center">
              <svg
                className="w-6 h-6 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                ></path>
              </svg>
              {/* <Link
                href={link(paths, paths.length + 1)}
                className="ml-1 text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2 dark:text-gray-400 dark:hover:text-black"
              > */}
              <>{product}</>
              {/* </Link> */}
            </div>
          </li>
        )}
      </ol>
    </nav>
  );
};
